import React from 'react';
import logoSAWbw from './SAW-Logo_weiss_RGB.svg';
import { defineMessages, useIntl } from 'react-intl';
import { Container as SemanticContainer } from 'semantic-ui-react';
import config from '@plone/volto/registry';
import { NavLink, Link } from 'react-router-dom';
import Anontools from '../Anontools/Anontools';
import { useSelector } from 'react-redux';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

const messages = defineMessages({
    FindUsOn: {
        id: 'Find us on',
        defaultMessage:
            'Find us on',
    },
});

const postFooter = (props) => {
    const intl = useIntl();

    const items = useSelector((state) => state.actions.actions.site_actions || []);
    const Container =
        config.getComponent({ name: 'Container' }).component || SemanticContainer;

    return (
        <Container className="layout saw-post-footer">
            <ul className="internal-links">
                {items.map((item, index) => (

                    item.url && (
                        <li key={item.url}>
                            <a href={item.url}>
                                {item.nav_title ?? item.title}
                            </a>

                        </li>
                    )

                ))}
                <li className="anontools">
                    <Anontools />
                </li>
            </ul>
            {/* <Anontools /> */}
        </Container >
    );
}

export default postFooter;